import { PageRouteBuilder } from "@common/route/page-route-builder";
import { ForgotPasswordPageComponent } from "./forgot-password-page.component";

export const forgotPasswordPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-forgot-password-page", ForgotPasswordPageComponent)
    .atUrl("/account/forgot-password")
    .requiresLogin(false)
    .requiresAnonymous(true)
    .build();
